import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import { handleError, setUser } from '../user';
import formatDate from '../../services/formatDate';
import mixpanelConstants from '../../constants/mixpanel';

export const setAccountErrors = createAction('SET_NURSE_ACCOUNT_ERRORS');
export const setAccountDisplay = createAction('SET_NURSE_ACCOUNT_DISPLAY');
export const setAccountResumeDisplay = createAction('SET_NURSE_ACCOUNT_RESUME_DISPLAY');
export const setAccountResumeDisplayMsg = createAction('SET_NURSE_ACCOUNT_RESUME_DISPLAY_MSG');
export const setShowAccountResumeDisplayMsg = createAction('SET_SHOW_NURSE_ACCOUNT_RESUME_DISPLAY_MSG');
export const setAccountMessage = createAction('SET_NURSE_ACCOUNT_MESSAGE');
export const setAccountName = createAction('SET_NURSE_ACCOUNT_NAME');
export const setAccountEmail = createAction('SET_NURSE_ACCOUNT_EMAIL');
export const setAccountNote = createAction('SET_NURSE_ACCOUNT_NOTE');
export const setAccountRole = createAction('SET_NURSE_ACCOUNT_ROLE');
export const setAccountPrvRole = createAction('SET_NURSE_ACCOUNT_PRVROLE');
export const setNurseOrgs = createAction('SET_NURSE_ORGS');
export const setAccountAddres = createAction('SET_NURSE_ACCOUNT_ADDRESS');
export const setAccountAddress2 = createAction('SET_NURSE_ACCOUNT_ADDRESS_2');
export const setAccountCity = createAction('SET_NURSE_ACCOUNT_CITY');
export const setAccountState = createAction('SET_NURSE_ACCOUNT_STATE');
export const setAccountStatus = createAction('SET_NURSE_ACCOUNT_STATUS');
export const setAccountPrvStatus = createAction('SET_NURSE_ACCOUNT_PRVSTATUS');
export const setAccountUserID = createAction('SET_NURSE_ACCOUNT_USER_ID');
export const setAccountZipcode = createAction('SET_NURSE_ACCOUNT_ZIPCODE');
export const setAccountPrimaryPhone = createAction('SET_NURSE_ACCOUNT_PRIMARY_PHONE');
export const setAccountAlternatePhone = createAction('SET_NURSE_ACCOUNT_ALTERNATE_PHONE');
export const setProfileFileType = createAction('SET_PROFILE_FILE_TYPE');
export const setProfilePreview = createAction('SET_PROFILE_PREVIEW');
export const setAccountRating = createAction('SET_NURSE_RATING');
export const setAccountYearsOfExperience = createAction('SET_NURSE_YEARS_OF_EXPERIENCE');

export const setReviewUnderProcessRedirPath = createAction('SET_REVIEW_UNDER_PROCESS_REDIR_PATH');
export const setIncompletedRedirPath = createAction('SET_INCOMPLETED_REDIR_PATH');
export const setAccoountAccessDenied = createAction('SET_NURSE_ACCOUNT_ACCESS_DENIED');
export const setBackBtnClicked = createAction('SET_BACK_BTN_CLICKED');

export const setAccountOldPassword = createAction('SET_NURSE_ACCOUNT_OLD_PASSWORD');
export const setAccountNewPassword = createAction('SET_NURSE_ACCOUNT_NEW_PASSWORD');
export const setAccountConfirmPassword = createAction('SET_NURSE_ACCOUNT_CONFIRM_PASSWORD');
export const clearProfilepic = createAction('CLEAR_USERPROFILEPIC');

export const resetAccount = createAction('REST_NURSE_ACCOUNT');

export const setAccountResumePath = createAction('SET_NURSE_ACCOUNT_RESUME_PATH');
export const setAccountResumeName = createAction('SET_NURSE_ACCOUNT_RESUME_NAME');
export const setAccountResumeType = createAction('SET_NURSE_ACCOUNT_RESUME_TYPE');
export const setAccountResumeFileId = createAction('SET_NURSE_ACCOUNT_RESUME_FILE_ID');
export const setAccountJobHistories = createAction('SET_NURSE_ACCOUNT_JOBHISTORIES');

export const setNurseReqDetails = createAction('SET_NURSE_REQ_DETAILS');
export const setNurseRequirements = createAction('SET_NURSE_REQUIREMENTS');
export const setRequirementSearchList = createAction('SET_NURSE_SEARCH_REQUIREMENTS');
export const setRequirementSearchTxt = createAction('SET_NURSE_REQ_SEARCH_TXT');

export const setNurseHistoryList = createAction('SET_NURSE_HISTORY_LIST');
export const setIsLoadingRequirement = createAction('SET_NURSE_IS_LOADING_REQUIREMENT');

export const setShowNurseNotiPref = createAction('SET_NURSE_SHOW_NOTI_PREF');

export const setShowNurseHelpDialog = createAction('SET_NURSE_SHOW_HELP');

const initialState = {
	accessDenied: false,
	address: '',
	address2: '',
	alternatePhoneNumber: '',
	backBtnClicked: true,
	city: '',
	confirmPassword: '',
	display: 'none',
	email: '',
	errors: {},
	incompletedRedirPath: '/nurse/onboarding-contact-info',
	isLoadingRequirement: false,
	jobHistories: [],
	message: '',
	name: '',
	newPassword: '',
	note: '',
	nurse_shift_history: [],
	oldPassword: '',
	primaryPhoneNumber: '',
	profileImageFileType: '',
	profileImagePreview: '',
	prv_role_id: '',
	prv_status: '',
	req_search_text: '',
	requirementDetails: [],
	requirementSearchList: [],
	resume_display: 'none',
	resume_display_msg: '',
	resume_file_id: -1,
	resume_file_name: '',
	resume_file_path: '',
	reviewUnderProcessRedirPath: '/nurse/registration/complete',
	role_id: '',
	show_resume_display_msg: false,
	showNurseHelpDialog: false,
	showNurseNotificationPref: false,
	state: '',

	status: '',
	user_id: '',
	user_orgs: [],
	userRequirements: [],

	years_of_experience: null,
	zipcode: ''
};

export default handleActions(
	{
		CLEAR_USERPROFILEPIC: (state) => ({ ...state, profileImagePreview: initialState.profileImagePreview }),
		REST_NURSE_ACCOUNT: () => initialState,
		SET_BACK_BTN_CLICKED: (state, action) => ({ ...state, backBtnClicked: action.payload }),
		SET_INCOMPLETED_REDIR_PATH: (state, action) => ({ ...state, incompletedRedirPath: action.payload }),
		SET_NURSE_ACCOUNT_ACCESS_DENIED: (state, action) => ({ ...state, accessDenied: action.payload }),
		SET_NURSE_ACCOUNT_ADDRESS: (state, action) => ({
			...state,
			address: action.payload.replace(/^\s+|\s+$/g, '').replace(/\s\s+/g, ' ')
		}),
		SET_NURSE_ACCOUNT_ADDRESS_2: (state, action) => ({
			...state,
			address2: action.payload.replace(/^\s+|\s+$/g, '').replace(/\s\s+/g, ' ')
		}),
		SET_NURSE_ACCOUNT_ALTERNATE_PHONE: (state, action) => ({ ...state, alternatePhoneNumber: action.payload }),
		SET_NURSE_ACCOUNT_CITY: (state, action) => ({
			...state,
			city: action.payload.replace(/^\s+|\s+$/g, '').replace(/\s\s+/g, ' ')
		}),
		SET_NURSE_ACCOUNT_CONFIRM_PASSWORD: (state, action) => ({ ...state, confirmPassword: action.payload }),
		SET_NURSE_ACCOUNT_DISPLAY: (state, action) => ({ ...state, display: action.payload }),
		SET_NURSE_ACCOUNT_EMAIL: (state, action) => ({ ...state, email: action.payload }),
		SET_NURSE_ACCOUNT_JOBHISTORIES: (state, action) => ({ ...state, jobHistories: action.payload }),
		SET_NURSE_ACCOUNT_MESSAGE: (state, action) => ({ ...state, message: action.payload }),
		SET_NURSE_ACCOUNT_NAME: (state, action) => ({
			...state,
			name: action.payload.replace(/^\s+|\s+$/g, '').replace(/\s\s+/g, ' ')
		}),
		SET_NURSE_ACCOUNT_NEW_PASSWORD: (state, action) => ({ ...state, newPassword: action.payload }),
		SET_NURSE_ACCOUNT_NOTE: (state, action) => ({ ...state, note: action.payload }),
		SET_NURSE_ACCOUNT_OLD_PASSWORD: (state, action) => ({ ...state, oldPassword: action.payload }),
		SET_NURSE_ACCOUNT_PRIMARY_PHONE: (state, action) => ({ ...state, primaryPhoneNumber: action.payload }),
		SET_NURSE_ACCOUNT_PRVROLE: (state, action) => ({ ...state, prv_role_id: action.payload }),
		SET_NURSE_ACCOUNT_PRVSTATUS: (state, action) => ({ ...state, prv_status: action.payload }),
		SET_NURSE_ACCOUNT_RESUME_DISPLAY: (state, action) => ({ ...state, resume_display: action.payload }),
		SET_NURSE_ACCOUNT_RESUME_DISPLAY_MSG: (state, action) => ({ ...state, resume_display_msg: action.payload }),
		SET_NURSE_ACCOUNT_RESUME_FILE_ID: (state, action) => ({ ...state, resume_file_id: action.payload }),
		SET_NURSE_ACCOUNT_RESUME_NAME: (state, action) => ({ ...state, resume_file_name: action.payload }),
		SET_NURSE_ACCOUNT_RESUME_PATH: (state, action) => ({ ...state, resume_file_path: action.payload }),
		SET_NURSE_ACCOUNT_RESUME_TYPE: (state, action) => ({ ...state, resume_file_type: action.payload }),

		SET_NURSE_ACCOUNT_ROLE: (state, action) => ({ ...state, role_id: action.payload }),
		SET_NURSE_ACCOUNT_STATE: (state, action) => ({ ...state, state: action.payload }),
		SET_NURSE_ACCOUNT_STATUS: (state, action) => ({ ...state, status: action.payload }),

		SET_NURSE_ACCOUNT_USER_ID: (state, action) => ({ ...state, user_id: action.payload }),
		SET_NURSE_ACCOUNT_ZIPCODE: (state, action) => ({ ...state, zipcode: action.payload }),
		SET_NURSE_HISTORY_LIST: (state, action) => ({ ...state, nurse_shift_history: action.payload }),

		SET_NURSE_IS_LOADING_REQUIREMENT: (state, action) => ({ ...state, isLoadingRequirement: action.payload }),
		SET_NURSE_ORGS: (state, action) => ({ ...state, user_orgs: action.payload }),
		SET_NURSE_RATING: (state, action) => ({ ...state, user_rating: action.payload }),
		SET_NURSE_REQ_DETAILS: (state, action) => ({ ...state, requirementDetails: action.payload }),
		SET_NURSE_REQ_SEARCH_TXT: (state, action) => ({ ...state, req_search_text: action.payload }),

		SET_NURSE_REQUIREMENTS: (state, action) => ({ ...state, userRequirements: action.payload }),
		SET_NURSE_SEARCH_REQUIREMENTS: (state, action) => ({ ...state, requirementSearchList: action.payload }),
		SET_NURSE_SHOW_HELP: (state, action) => ({ ...state, showNurseHelpDialog: action.payload }),
		SET_NURSE_SHOW_NOTI_PREF: (state, action) => ({ ...state, showNurseNotificationPref: action.payload }),

		SET_NURSE_YEARS_OF_EXPERIENCE: (state, action) => ({ ...state, years_of_experience: action.payload }),

		SET_PROFILE_FILE_TYPE: (state, action) => ({ ...state, profileImageFileType: action.payload }),

		SET_PROFILE_PREVIEW: (state, action) => ({ ...state, profileImagePreview: action.payload }),

		SET_REVIEW_UNDER_PROCESS_REDIR_PATH: (state, action) => ({ ...state, reviewUnderProcessRedirPath: action.payload }),

		SET_SHOW_NURSE_ACCOUNT_RESUME_DISPLAY_MSG: (state, action) => ({
			...state,
			show_resume_display_msg: action.payload
		})
	},
	initialState
);

export const updateAccountContact = () => {
	return function (dispatch, getState) {
		const { newPassword, confirmPassword } = getState().nurseAccount;
		if (newPassword !== confirmPassword) {
			alert('Passwords do not match');
			return;
		}

		Agent.updateNurseDetails(getState().nurseAccount).then((response) => {
			if (response.ok) {
				alert('Your personal information has been saved.');
				trackNurseDetailUpdate(getState());
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

function trackNurseDetailUpdate(appState) {
	let user = appState.nurseAccount;

	mixpanel.identify(appState.user.id);
	mixpanel.people.set({
		$city: user.city ? user.city : null,
		$country_code: user.city ? 'US' : null,
		$first_name: user.name.split(' ')[0],
		$last_name: user.name.split(' ')[1],
		$phone: user.primaryPhoneNumber,
		$region: user.state,
		alternate_phone_number: user.alternatePhoneNumber,
		zipcode: user.zipcode
	});

	mixpanel.register({
		Email: user.email,
		'First Name': user.name.split(' ')[0],
		'Last Name': user.name.split(' ')[1]
	});

	mixpanel.track(mixpanelConstants.UPDATE_PERSONAL_DETAILS, {
		alternatePhoneNumber: user.alternatePhoneNumber,
		city: user.city ? user.city : null,
		countryCode: user.city ? 'US' : null,
		primaryPhoneNumber: user.primaryPhoneNumber,
		region: user.state,
		zipcode: user.zipcode
	});
}

export const fetchAccountContact = () => {
	return function (dispatch) {
		Agent.userContact().then((response) => {
			if (response.ok) {
				dispatch(setUser(response.data));
				dispatch(setAccountUserID(response.data.id));
				dispatch(setAccountName(response.data.first_name + ' ' + response.data.last_name));
				dispatch(setAccountEmail(response.data.email != null ? response.data.email : ''));
				dispatch(setAccountRating(response.data.user_rating));
				dispatch(setAccountAddres(response.data.address != null ? response.data.address : ''));
				dispatch(setAccountAddress2(response.data.additional_address != null ? response.data.additional_address : ''));
				dispatch(setAccountCity(response.data.city != null ? response.data.city : ''));
				dispatch(
					setAccountRole(response.data.role_id != null ? (response.data.role_id > 0 ? response.data.role_id : '') : '')
				);
				dispatch(
					setAccountPrvRole(
						response.data.role_id != null ? (response.data.role_id > 0 ? response.data.role_id : '') : ''
					)
				);
				dispatch(setAccountState(response.data.state != null ? response.data.state : ''));
				dispatch(setAccountStatus(response.data.status != null ? response.data.status : ''));
				dispatch(setAccountPrvStatus(response.data.status != null ? response.data.status : ''));
				dispatch(setAccountZipcode(response.data.zip != null ? response.data.zip : ''));
				dispatch(setAccountPrimaryPhone(response.data.phone != null ? response.data.phone : ''));
				dispatch(setAccountNote(response.data.user_notes != null ? response.data.user_notes : ''));
				dispatch(setAccountAlternatePhone(response.data.alt_phone != null ? response.data.alt_phone : ''));
				dispatch(setProfilePreview(response.data.photo_location != null ? response.data.photo_location : ''));
				dispatch(setProfileFileType(response.data.file_type != null ? response.data.file_type : ''));
				dispatch(setNurseOrgs(response.data.user_orgs));
				dispatch(
					setAccountYearsOfExperience(
						response.data.years_of_experience !== null ? response.data.years_of_experience.toString() : ''
					)
				);
				dispatch(
					setAccountResumePath(response.data.user_resumes[0] ? response.data.user_resumes[0].resume_location : '')
				);
				dispatch(
					setAccountResumeName(response.data.user_resumes[0] ? response.data.user_resumes[0].resume_file_name : '')
				);
				dispatch(
					setAccountResumeType(response.data.user_resumes[0] ? response.data.user_resumes[0].resume_file_type : '')
				);
				dispatch(setAccountResumeFileId(response.data.user_resumes[0] ? response.data.user_resumes[0].id : -1));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const uploadProfileImage = (file) => {
	return function (dispatch) {
		if (file) {
			dispatch(setAccountDisplay('block'));
			Agent.uploadFileOnS3(file).then((response) => {
				if (response.ok) {
					dispatch(setProfilePreview(response.data.path));
					dispatch(setProfileFileType(response.data.content_type));
				} else {
					alert('Failed to upload user image. Please check you file type and file size.');
				}
				dispatch(setAccountDisplay('none'));
			});
		}
	};
};

//JobHistory related functions
export const uploadResumeFile = (file) => {
	return function (dispatch, getState) {
		if (file) {
			dispatch(setAccountResumePath(''));
			dispatch(setAccountResumeDisplay('inline-block'));
			dispatch(setAccountResumeDisplayMsg(''));
			Agent.uploadResume(file, getState().nurseAccount.user_id).then((response) => {
				if (response.ok) {
					dispatch(setAccountResumeDisplay('none'));
					dispatch(setAccountResumePath(response.data.path));
					dispatch(setAccountResumeName(file.name));
					dispatch(setAccountResumeFileId(response.data.id));
					dispatch(setAccountResumeDisplayMsg('Successfully uploaded Resume'));
					dispatch(setShowAccountResumeDisplayMsg(true));

					trackResumeUpload(getState());
				} else {
					dispatch(setAccountResumeDisplay('none'));
					alert('Failed to upload user image. Please check you file type and file size.');
				}
			});
		}
	};
};

function trackResumeUpload(appState) {
	mixpanel.track(mixpanelConstants.UPLOAD_RESUME, {
		origin: 'account'
	});

	mixpanel.identify(appState.user.id);
	mixpanel.people.set({
		resume_uploaded: true
	});
}

export const fetchNurseJobHistories = () => {
	return function (dispatch, getState) {
		Agent.getUserJobHistories(getState().nurseAccount.user_id).then((response) => {
			if (response.ok) {
				dispatch(setAccountJobHistories(response.data.job_history));
				//dispatch(setGlobalUserResumeFile(response.data.resume_preview)) this is old way
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const createNurseJobHistory = (formObj) => {
	return function (dispatch) {
		Agent.createJobHistoryByNurse(
			formatDate.clientDateToYyMmDd(formObj.start_date),
			formObj.end_date != null ? formatDate.clientDateToYyMmDd(formObj.end_date) : null,
			formObj.title,
			formObj.company,
			formObj.city,
			formObj.state,
			formObj.description
		).then((response) => {
			if (response.ok) {
				dispatch(fetchNurseJobHistories());

				mixpanel.track(mixpanelConstants.ADD_NEW_JOB_HISTORY, {
					city: formObj.city,
					company: formObj.company,
					description: formObj.description,
					endDate: formObj.end_date,
					startDate: formObj.start_date,
					state: formObj.state,
					title: formObj.title
				});
			} else {
				alert('Job history creation failed: ' + (response.data === null ? 'something went wrong' : response.data));
			}
		});
	};
};

export const deleteNurseJobHistory = (id) => {
	return function (dispatch) {
		Agent.deleteUserJobHistory(parseInt(id)).then((response) => {
			if (response.ok) {
				dispatch(fetchNurseJobHistories());
				mixpanel.track(mixpanelConstants.DELETE_JOB_HISTORY, { id: id });
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const updateNurseJobHistoryByAdmin = (id, formObj) => {
	return function (dispatch) {
		Agent.updateJobHistoryByNurse(
			parseInt(id),
			formatDate.clientDateToYyMmDd(formObj.start_date),
			formObj.end_date != null ? formatDate.clientDateToYyMmDd(formObj.end_date) : null,
			formObj.title,
			formObj.company,
			formObj.city,
			formObj.state,
			formObj.description
		).then((response) => {
			if (response.ok) {
				dispatch(fetchNurseJobHistories());

				mixpanel.track(mixpanelConstants.UPDATE_JOB_PROFILE, {
					city: formObj.city,
					company: formObj.company,
					description: formObj.description,
					endDate: formObj.end_date,
					id: id,
					startDate: formObj.start_date,
					state: formObj.state,
					title: formObj.title
				});
			} else {
				alert('Job history update failed: ' + (response.data === null ? 'something went wrong' : response.data));
			}
		});
	};
};

//Requirement
export const fetchNurseRequirements = () => {
	return function (dispatch) {
		Agent.getNurseRequirements().then((response) => {
			if (response.ok) {
				dispatch(setNurseRequirements(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const fetchNurseRequirementToAdd = (req_id) => {
	return function (dispatch) {
		dispatch(setIsLoadingRequirement(true));
		Agent.getUserRequirementToAdd(req_id).then((response) => {
			dispatch(setIsLoadingRequirement(false));
			if (response.ok) {
				dispatch(setNurseReqDetails(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const searchRequirementList = (req_search_text) => {
	return function (dispatch) {
		if (req_search_text === '' || req_search_text == undefined) {
			req_search_text = undefined;
		}

		Agent.searchUserRequirement(req_search_text).then((response) => {
			if (response.ok) {
				dispatch(setRequirementSearchList(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

export const deleteNurseRequirements = (req_id) => {
	return function (dispatch, getState) {
		Agent.deleteRequirementByNurse(getState().nurseAccount.user_id, req_id).then((response) => {
			if (response.ok) {
				dispatch(fetchNurseRequirements());
				trackRequirementRemove(getState().nurseAccount.userRequirements, req_id, getState().nurseAccount.user_id);
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

const trackRequirementRemove = (userRequirements, req_id, user_id) => {
	let deletedRequirement = userRequirements.find((req) => req.id == req_id);
	let trackingKey = (deletedRequirement.title + ' uploaded').toLowerCase().replace(/ /g, '_');
	mixpanel.identify(user_id);
	mixpanel.people.set({ [trackingKey]: false });
	mixpanel.track(mixpanelConstants.DELETE_REQUIRED_DOCS, {
		documentId: req_id,
		documentTitle: deletedRequirement.title
	});
};

export const getNurseShiftHistory = () => {
	return function (dispatch, getState) {
		const { user_id } = getState().nurseAccount;
		Agent.getNurseShiftHistory(user_id).then((response) => {
			if (response.ok) {
				dispatch(setNurseHistoryList(response.data));
			} else {
				alert("Couldn't get nurse shift history", response.data);
			}
		});
	};
};

export const updateShiftVisibility = (preference_id, status) => {
	return function () {
		Agent.updateShiftVisibility(preference_id, status).then((response) => {
			if (response.ok) {
			} else {
				alert("Couldn't update shift Visibility", response.data);
			}
		});
	};
};
